export const CONFIRM_REASON = 'confirm';
export const DELETE_REASON = 'delete';
export const CANCEL_REASON = 'cancel';
